import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AnnouncementBarProvider } from "./contexts/AnnouncementBarContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AnnouncementBarProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </AnnouncementBarProvider>
    </I18nextProvider>
  );
}

export default App;